// extracted by mini-css-extract-plugin
export default {"container":"UFf9k5s9w8fEbFaRu4Y3"};